import { render, staticRenderFns } from "./OwarmStats.vue?vue&type=template&id=275a3ace"
import script from "./OwarmStats.vue?vue&type=script&lang=js"
export * from "./OwarmStats.vue?vue&type=script&lang=js"
import style0 from "./OwarmStats.vue?vue&type=style&index=0&id=275a3ace&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports